module.exports = __webpack_public_path__ + "media/images/background_home-520w-5660ca14.jpg";